import results from '../data/results.json';

export function testAnswers(props, criteria) {
  if (criteria.answers == null) { return false; }

  if (criteria.answers[1]) {
    return criteria.answers[1].indexOf(props.answers[1]) !== -1;
  }
  if (criteria.answers[2]) {
    return criteria.answers[2].indexOf(props.answers[2]) !== -1;
  }
  return false;
}

export function testStat(name, stats) {
  if (results[name] && results[name].criteria) {
    return results[name].criteria[1] < stats[name].value;
  }

  return stats[name].value == false;
}

export function testStats(props, criteria) {
  const {stats} = props;

  if (criteria.stats == null) { return false; }

  return criteria.stats.filter((name) => testStat(name, stats))[0];
}



// WEBPACK FOOTER //
// ./src/utils/checks.js